import { registerFormatter } from '@philips-emr/tws-core/lib/services/model-service';
import { createAlphanumericFormatter } from '@philips-emr/tws-model/lib/generators/';

import employerIdentificationNumberValidator from '../validators/cnpj-formatters';

export const CNPJ = 'employee-identification-number';

const CnpjFormatter = createAlphanumericFormatter({
  name: CNPJ,
  mask: '00.000.000/0000-00',
  validate: employerIdentificationNumberValidator,
  invalidMessage: 'provider.invalid-ein',
});

export default registerFormatter('cnpj', CnpjFormatter);
